<template>
    <p class="text-base tablet-sm:text-xl my-6 leading-8 px-1"><slot></slot></p>
</template>
